// Column presets for the Screen tab. Each builds the statistic columns for a global period
// (or an explicit From month-end when the period is "custom"); the "custom" column set
// hands control to the full picker under Advanced.
export const PERIOD_OPTIONS = ['1y', '3y', '5y', '7y', '10y', 'custom'];

const point = (statistic, p, start) => ({ statistic, period: p, start: p === 'custom' ? start : undefined, rolling: null, summary: 'latest' });
const roll = (statistic, p, start, rolling, summary) => ({ statistic, period: p, start: p === 'custom' ? start : undefined, rolling, summary });

export const COLUMN_SETS = {
  core: {
    label: 'Core (excess return, IR, max drawdown)',
    build: (p, start) => [point('excess_return', p, start), point('information_ratio', p, start), point('max_drawdown', p, start)],
  },
  returns: {
    label: 'Returns (return, excess, active, Sharpe)',
    build: (p, start) => [point('ann_return', p, start), point('excess_return', p, start), point('active_return', p, start), point('sharpe', p, start)],
  },
  risk: {
    label: 'Risk (volatility, drawdown, down capture, beta)',
    build: (p, start) => [point('volatility', p, start), point('max_drawdown', p, start), point('down_capture', p, start), point('beta', p, start)],
  },
  consistency: {
    label: 'Consistency (rolling 12m hit rate, worst and % positive active)',
    build: (p, start) => [roll('hit_rate', p, start, 12, 'mean'), roll('active_return', p, start, 12, 'min'), roll('active_return', p, start, 12, 'pct_positive')],
  },
  custom: { label: 'Custom (choose under Advanced)', build: null },
};
